import { useState } from 'react'

import { SectionState } from 'states/PromoPageState/state'
import { AdminHeaderBlockElem } from 'components/AdminV2/UI/HeaderBlockElem/AdminHeaderBlockElem'
import { AdminInput } from 'components/AdminV2/UI/Input/AdminInput'
import { AdminTextArea } from 'components/AdminV2/UI/TextArea/AdminTextArea'
import { FaqData } from 'types/types'

import s from './FaqEl.module.scss'

type FaqElProps = {
  index: number
  localPromoState: SectionState
  setLocalPromoState: React.Dispatch<React.SetStateAction<SectionState>>
  setDraggable?: React.Dispatch<React.SetStateAction<boolean>>
}

export const FaqEl = ({ index, localPromoState, setLocalPromoState }: FaqElProps) => {
  const [state, setState] = useState<SectionState>(localPromoState)

  const faqData = state.content as FaqData[]

  const question = faqData[index]?.question
  const answer = faqData[index]?.answer
  const hrefText = faqData[index]?.hrefText
  const href = faqData[index]?.href

  const changeInputHandler = (value: string, key: keyof FaqData) => {
    const stateCopy = { ...state }
    const faqData = stateCopy.content as FaqData[]
    ;(faqData[index][key] as string) = value
    setState(stateCopy)
  }

  const deleteFaqHandler = () => {
    const stateCopy = { ...state }
    let faqData = stateCopy.content as FaqData[]

    faqData = faqData.filter((faq) => faq.index !== index)

    for (let i = 0; i < faqData.length; i++) {
      faqData[i].index = i
    }

    stateCopy.content = faqData

    setLocalPromoState(stateCopy)
  }

  return (
    <div className={s.faqEl}>
      <AdminHeaderBlockElem index={index} text={'Вопрос-ответ'} onClick={deleteFaqHandler} />

      <div className={s.wrap}>
        <AdminTextArea
          label="Вопрос"
          value={question}
          onChange={(value: string) => changeInputHandler(value, 'question')}
          labelSize="16px"
        />
        <AdminTextArea
          label="Ответ"
          value={answer}
          onChange={(value: string) => changeInputHandler(value, 'answer')}
          labelSize="16px"
        />

        <AdminInput
          label="Текст ссылки"
          value={hrefText || ''}
          onChange={(value: string) => changeInputHandler(value, 'hrefText')}
          labelSize="16px"
        />
        <AdminInput
          label="Ссылка"
          value={href || ''}
          onChange={(value: string) => changeInputHandler(value, 'href')}
          labelSize="16px"
        />
      </div>
    </div>
  )
}
